// Just here to keep things DRY
export const isPhoneGap = 
	window.location.href.indexOf('?phonegap=1') > 0 || 
	window.location.href.indexOf('com.josiahbryan.walksafe') > 0;